import { Cookie } from 'lucide-react';

import { Button } from '@/design-system/ui/Button';
import { IconTile } from '@/design-system/patterns/IconTile';
import { saveConsent } from '@/privacy/consent';

/**
 * Aviso de cookies do primeiro acesso (e de novo a cada 12 meses ou quando o catálogo
 * muda). Três saídas com o mesmo peso — "Personalizar", "Só essenciais" e "Aceitar
 * todos" — e nada além dos essenciais é guardado antes da escolha. Não bloqueia a tela.
 */
export default function CookieBanner({
  onCustomize,
  onPolicy,
}: {
  onCustomize: () => void;
  onPolicy: () => void;
}) {
  return (
    <section
      aria-label="Aviso de cookies"
      className="fixed inset-x-4 bottom-4 z-[65] mx-auto flex max-w-190 flex-wrap items-center gap-3.5 rounded-dialog border border-line-input bg-white px-4.5 py-4 shadow-dialog"
    >
      <IconTile size="md">
        <Cookie aria-hidden />
      </IconTile>
      <p className="m-0 min-w-60 flex-1 text-small text-pretty text-ink-secondary">
        <strong className="text-ink">Sua privacidade importa.</strong> Usamos cookies essenciais para o login
        funcionar e, com a sua permissão, para lembrar preferências neste navegador.{' '}
        <Button variant="link" size="sm" className="text-small" onClick={onPolicy}>
          Política de Cookies
        </Button>
      </p>
      <div className="flex flex-wrap gap-2">
        <Button variant="secondary" onClick={onCustomize}>
          Personalizar
        </Button>
        <Button variant="secondary" onClick={() => saveConsent('essential')}>
          Só essenciais
        </Button>
        <Button variant="secondary" onClick={() => saveConsent('all')}>
          Aceitar todos
        </Button>
      </div>
    </section>
  );
}
